import PropTypes from 'prop-types';
import React from 'react';

import './IndustryTable.scss';
import TdContent from './TdContent/TdContent';

export default class IndustryTable extends React.PureComponent {
    static propTypes = {
        /**
         * array of table headers
         */
        theads: PropTypes.array,
        /**
         * array of row data
         */
        rowRecords: PropTypes.arrayOf(
            PropTypes.arrayOf(
                PropTypes.shape({
                    data: PropTypes.oneOfType([
                        PropTypes.string,
                        PropTypes.array,
                    ]),
                    description: PropTypes.string,
                })
            )
        ),
        /**
         * column one width
         */
        colOneWidth: PropTypes.string,
        /**
         * column one span
         */
        colOneSpan: PropTypes.number,
    };

    static defaultProps = {
        bodyTHAlign: 'top',
        theads: [],
        rowRecords: [],
        colOneWidth: '50%',
        colOneSpan: 1,
    };

    renderTableHeaders = () => {
        if (this.props.theads && this.props.theads.length > 0) {
            let colOneHeader = (
                <th
                    scope="col"
                    width={this.props.colOneWidth}
                    colSpan={this.props.colOneSpan}
                >
                    {this.props.theads[0]}
                </th>
            );
            return (
                <thead>
                    <tr>
                        {colOneHeader}
                        {this.props.theads.slice(1).map((thead, idx) => (
                            <th scope="col" className="text-center" key={idx}>
                                {thead}
                            </th>
                        ))}
                    </tr>
                </thead>
            );
        }
    };

    renderSingleRow = (rowRecord, rowNum) => {
        if (rowRecord.length > 0) {
            let tds = rowRecord.slice(1).map((ele, idx) => {
                return (
                    <td key={idx} align="center">
                        <TdContent
                            data={ele.data}
                            tooltipMsg={ele.description}
                        />
                    </td>
                );
            });

            return (
                <tr key={rowNum}>
                    <th scope="row" align={this.props.bodyTHAlign}>
                        {rowRecord[0].data}
                    </th>
                    {tds}
                </tr>
            );
        }
    };

    render() {
        return (
            <div className="component-Employer-Benefits-IndustryTable">
                <table className="table table-striped">
                    {this.renderTableHeaders()}
                    <tbody>
                        {this.props.rowRecords.map((rowRecord, idx) =>
                            this.renderSingleRow(rowRecord, idx)
                        )}
                    </tbody>
                </table>
            </div>
        );
    }
}
